import { useUser } from '@corratech/pylot-auth-manager'
import Script from 'next/script'
import { useCart } from '@corratech/pylot-cart-manager'

/**
 * Adds yotpo loyality script and customer information.
 */
export const YotpoLoyalty = ({ guid }: { guid: string }) => {
    const { customer } = useUser()
    const { data: cartData } = useCart()
    let customerIdentification = {}
    if (customer) {
        const { identity, tags, token } = customer.yotpo_identification
        customerIdentification = {
            'data-authenticated': 'true',
            'data-email': customer.email,
            'data-id': identity,
            'data-tags': tags,
            'data-token': token
        }
    }

    const cart = cartData?.data?.cart
    const subtotal = cart?.prices?.subtotal_excluding_tax?.value!
    const cartSubTotalInCents = Math.round(subtotal * 100)

    return (
        <div className="yotpo-loyalty">
            <Script
                src={`//cdn-widgetsrepository.yotpo.com/v1/loader/${guid}`}
                strategy="lazyOnload"
            />
            {customer && (
                <>
                    <div
                        id="yotpo-loyalty-cart-data"
                        data-free-product-points="0"
                        data-applied-coupon-points="0"
                        data-cart-id={cartData?.data?.cart?.id}
                        data-has-paid-product=""
                        data-has-free-product=""
                    />
                    <div
                        id="yotpo-loyalty-checkout-data"
                        cart-subtotal-cents={cartSubTotalInCents} // NOSONAR
                    />
                </>
            )}
            <div
                id="swell-customer-identification"
                style={{ display: 'none' }}
                {...customerIdentification}
            />
        </div>
    )
}
